import { AsyncThunk, AnyAction } from "@reduxjs/toolkit";

type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>;

type PendingAction = ReturnType<GenericAsyncThunk["pending"]>;
type RejectedAction = ReturnType<GenericAsyncThunk["rejected"]>;
type FulfilledAction = ReturnType<GenericAsyncThunk["fulfilled"]>;

export function isPendingAction(key: string) {
  return (action: AnyAction): action is PendingAction =>
    new RegExp(`${key}/.+/pending`).test(action.type);
}

export function isRejectedAction(key: string) {
  return (action: AnyAction): action is RejectedAction =>
    new RegExp(`${key}/.+/rejected`).test(action.type);
}

export function isFulfilledAction(key: string) {
  return (action: AnyAction): action is FulfilledAction =>
    new RegExp(`${key}/.+/fulfilled`).test(action.type);
}
